import { Fragment } from "react";
import type { ReactNode } from "react";

import type { PropertyListing } from "@gql";

import * as styles from "./Details.styles";

const DETAILS = {
  property_type: "Property Type",
  building_type: "Building Type",
  stories_total: "Storeys",
  community_name: "Community Name",
  ownership_type: "Title",
  size_total_text: "Land Size",
  constructed_date: "Built In",
  ammenities_near_by: "Amenities Nearby",
  community_features: "Community Features",
  parking_space_total: "Parking Spaces",
  road_type: "Road Type",
} as const;

const BUILDING_DETAILS = {
  basement_development: "Basement Development",
  basement_type: "Basement Type",
  half_bath_total: "Partial Bathroom",
  cooling_type: "Cooling",
  exterior_finish: "Exterior Finish",
  flooring_type: "Flooring",
  foundation_type: "Foundation",
  heating_fuel: "Heating Fuel",
  heating_type: "Heating Type",
  construction_style_attachment: "Style",
  sewer: "Sewer",
  utility_water: "Water",
} as const;

interface Props {
  propertyListing: Pick<
    PropertyListing,
    "listingId" | "bedroomsTotal" | "bathroomTotal" | "parking" | "parkingType" | "publicRemarks"
  >;
}

const Details = ({ propertyListing }: Props) => {
  const renderDetailEntry = (content: ReactNode) => {
    return <div css={styles.detailEntry}>{content}</div>;
  };

  const renderMLSNumber = () => {
    if (!propertyListing.listingId) return null;

    return renderDetailEntry(
      <>
        <label className="mls-number red">MLS® Number</label>
        <p>{propertyListing.listingId}</p>
      </>,
    );
  };

  const renderBedrooms = () => {
    if (!propertyListing.bedroomsTotal) return null;

    return renderDetailEntry(
      <>
        <label className="red">
          <i className="fa fa-bed" /> Bed
        </label>
        <p>{propertyListing.bedroomsTotal}</p>
      </>,
    );
  };

  const renderBathroom = () => {
    if (!propertyListing.bathroomTotal) return null;

    return renderDetailEntry(
      <>
        <label className="red">
          <i className="fa fa-bath" /> Bath
        </label>
        <p>{propertyListing.bathroomTotal}</p>
      </>,
    );
  };

  const renderParking = () => {
    if (!propertyListing.parking) return null;

    return renderDetailEntry(
      <>
        <label className="red">Parking Type</label>
        <p>{propertyListing.parkingType}</p>
      </>,
    );
  };

  const renderDetails = () => {
    return Object.keys(DETAILS).map(key => {
      // @ts-expect-error need to fix this
      if (!propertyListing[key]) return;

      return renderDetailEntry(
        <Fragment key={key}>
          {/* @ts-expect-error need to fix this */}
          <label className="red">{DETAILS[key]}</label>
          {/* @ts-expect-error need to fix this */}
          <p>{propertyListing[key]}</p>
        </Fragment>,
      );
    });
  };

  const renderBuildingDetails = () => {
    const buildingDetails = Object.keys(BUILDING_DETAILS).reduce((items, key) => {
      // @ts-expect-error need to fix this
      if (propertyListing[key]) {
        items.push(
          renderDetailEntry(
            <Fragment key={key}>
              {/* @ts-expect-error need to fix this */}
              <label className="red">{BUILDING_DETAILS[key]}</label>
              {/* @ts-expect-error need to fix this */}
              <p>{propertyListing[key]}</p>
            </Fragment>,
          ),
        );
      }

      return items;
    }, [] as ReactNode[]);

    if (buildingDetails.length === 0) return null;

    return (
      <div css={styles.container}>
        <h2>Building Details</h2>
        <div css={styles.detailsContainer}>{buildingDetails}</div>
      </div>
    );
  };

  return (
    <div>
      <div css={styles.container}>
        <h2>Description</h2>
        <p>{propertyListing.publicRemarks}</p>
      </div>

      <div css={styles.container}>
        <h2>Details</h2>

        <div css={styles.detailsContainer}>
          {renderMLSNumber()}
          {renderBedrooms()}
          {renderBathroom()}
          {renderParking()}
          {renderDetails()}
        </div>
      </div>

      {renderBuildingDetails()}
    </div>
  );
};

export { Details };
